// extracted by mini-css-extract-plugin
module.exports = {"fontsize":"TicketingForm_fontsize__3e65X","bold":"TicketingForm_bold__fp4JR","ticketGroup":"TicketingForm_ticketGroup__RQvc0","hr":"TicketingForm_hr__M4DDh"};